import { defineStore } from 'pinia'
import actions from './actions.js';
import mutations from './mutations.js';
import getters from './getters.js';

import addressActions from '../address/actions-refactored.js';
import addressMutations from '../address/mutations.js';
import addressGetters from '../address/getters.js';

export function paymentStore() {

    return defineStore('paymentStore', {
        state: () => {
            return {
                pay_type: '',
                pay_mode: 'full_payment',
                cartData: null,
                CartTotal: {},
                payment_modes: null,
                showButtonLoader: false,
                modalContent: {
                    message: '',
                },
                flagShowModal: false,
                processStatus: false,
                paymentSkeleton: true,
                gatewayComponentKey: 1,
                gatwayStatus: {},
                createPlanData: null,
                first_split_amount: null,
    
    
                // address state
                userLocation: null,
                address_id: false,
                guestData: {
                    first_name: '',
                    last_name: '',
                    email: '',
                    password: '',
                    confirm_password: '',
                    is_guest: 1
                },
                addressData: {
                    billing_address: '',
                    billing_address_two: '',
                    billing_city: '',
                    billing_country: '',
                    billing_country_short: '',
                    billing_first_name: '',
                    billing_last_name: '',
                    billing_phone: '',
                    billing_postcode: '',
                    billing_same: 1,
                    billing_state: '',
                    order_note: null,
                    shipping_address: '',
                    shipping_address_two: '',
                    shipping_city: '',
                    shipping_country: '',
                    shipping_country_short: '',
                    shipping_first_name: '',
                    shipping_last_name: '',
                    shipping_phone: '',
                    shipping_postcode: '',
                    shipping_state: '',
                },
                errorData: {},
            }
        },
        getters: { ...getters, ...addressGetters },
        actions: {
            ...actions, ...addressActions, _router: () => useRouter(), _route: () => useRoute(), commitMutation: function (mutationToCall, data) {
    
                try {
                    const mergedMutations = { ...mutations, ...addressMutations };
                    mergedMutations[mutationToCall](this, data)
                } catch (error) {
                    console.error('Payment MUTATION ERROR - ', mutationToCall, data, error)
                    throw error
                }
            }
        },
    })()
}


